import React, { useEffect, useState } from "react";
import { Card, Col, Row, Modal, ModalBody, Spinner } from "reactstrap";
import CommonTable from "../../Component/BasicComponents/Common/CommonTable";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import CustomInput from "../../Component/BasicComponents/CustomInput";
import { Btn } from "../../AbstractElements";
import { useUpdateExpenseAmount } from "./hooks/useExpense";
import { showToast } from "../../utils/toastUtils";
import { FaEye} from "react-icons/fa";


interface ExpesenFormInterface {
  expAmount: string;
  Remark: string;
}


const ImageCell = ({ImageString}:{ImageString:string})=>{
  const [loading,setLoading] = useState(true);
  const BASE_URL = "https://tspc-development.truesales.in/media?id=";
  const imgSrc = ImageString ? `${BASE_URL}${ImageString}`:"https://via.placeholder.com/100?text=No+Image";
  
  return (
      <>
       {loading && (
        <div className="d-flex justify-content-center align-items-center">
          <Spinner color="success" style={{color:'green', width: "2rem", height: "2rem" }} />
        </div>
      )}
       <img
        src={imgSrc}
        alt="avatar"
        style={{
          width:600,
          height:500,
          cursor:'pointer',
          display: loading ? "none" : "inline-block",
        }}
        onLoad={() => setLoading(false)}
        onError={() => setLoading(false)}
       />
      </>
    )
  }

const ExpTabsContentTable = ({data,columns,}: {data: any[];columns: { label: string; key: string }[];}) => {

  const [modal, setModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const closeModal = () => setModal(!modal);
  const toggleModal = () => setModal(!modal);
  const [expense_modal, setexpense_modal] = useState(false);
  const [ExpenseAmount, setExpeneseAmount] = useState<number | undefined>(undefined);
  const [ExpListID, setExpListID] = useState<number | undefined>(undefined);

  const [ExpesenForm, setExpesenForm] = useState<ExpesenFormInterface>({expAmount: "",Remark: "", });
  const [Loading,setLoading] = useState<boolean>(false);
  const { mutate: UpdateExpenseAmount } = useUpdateExpenseAmount();

   

  const openImageModal = (imageUrl:any) => {
    // alert(imageUrl);
    setSelectedImage(imageUrl);
    toggleModal();

  };
  
  useEffect(()=>{
    if(Array.isArray(data)){  
        if(data.length == 0){
        setLoading(true);
          setTimeout(()=>{
        setLoading(false);
      },3000);
        }else{
        setLoading(false);
        }
    }else{ 
      setLoading(true);
    }
  },[data]);

    if (Loading) {
    return (
      <div className="d-flex justify-content-center p-3">
        <Spinner style={{color:'green'}} /> {/* Bootstrap spinner */}
      </div>
    );
  }



  const handleSubmit = (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    let value = Number(ExpesenForm.expAmount);

    if (!isNaN(value) && value > 1) {
      const Expense_List_ID = Number(ExpListID);
      const ReqBody = {
        ExpAprAmount: ExpenseAmount,
        ExpAuditAmount: value,
        remark: String(ExpesenForm.Remark),
        action: "changeExp",
      };
      UpdateExpenseAmount({ id: Expense_List_ID, ReqBody: ReqBody });
    } else {
      showToast.error("Plase Enter Valid  Audit Amount");
    }

    //state clear
    setExpeneseAmount(undefined);
    setExpListID(undefined);
    setexpense_modal(false);
    setExpesenForm({
      expAmount: "",
      Remark: "",
    });
  };

  const handleAuditModal = (
    id: number,
    value: any,
    ExpRemark: any,
    ExpListId: any,
    approvebyManager: any
  ) => {
    setexpense_modal(!expense_modal);
    setExpesenForm((prev: any) => ({
      ...prev,
      expAmount: value,
      Remark: ExpRemark,
    }));
    setExpeneseAmount(approvebyManager);
    setExpListID(ExpListId);
  };
  const handleExpenseInput = (key: any, val: any) => {
    setExpesenForm((pre: any) => ({
      ...pre,
      [key]: val,
    }));
  };

  // console.log('selectedImage',selectedImage);

  return (
    <Col sm="12">
      <Card>
        <Row className="card-block">
          <Col sm="12" lg="12" xl="12">
            <div style={{ overflowX: "auto", width: "100%" }}>
              <CommonTable
                headData={columns.map((col, index) => ({
                  id: index,
                  head: col.label,
                }))}
              >
                {data.map((row: any, index: number) => (
                  <tr key={index}>
                    {columns.map((col) => (

                      <td key={col.key}>
                        {col.key === "expenseHead" ? (
                          <div>

                            <strong style={{ color: "#509FDA" }}>
                              {row[col.key]}
                            </strong>
                            {row.description && (
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "gray",
                                  marginTop: "3px",
                                }}
                              >
                                {row.description}
                              </div>
                            )}
                          </div>

                        ) : col.key === "attachment" && row[col.key] ?(
                          <>
                          { 
                          row[col.key] =='No attachment'? 'N/A' /*<FaEyeSlash/>*/ :(<FaEye  style={{ fontSize: "15px", cursor: "pointer" }} onClick={()=>openImageModal(row[col.key])}/>)                          
                          }
                          </>
                        ) : (col.key === "audited" || col.key === "expenseRemark") &&
                          row.hasOwnProperty(col.key) ? (
                          <p
                            style={{ color: "blue", cursor: "pointer" }}
                            onClick={() => {
                              handleAuditModal(
                                index,
                                row["audited"],
                                row["expenseRemark"],
                                row["ExpListId"],
                                row["approvebyManager"]
                              );
                            }}
                          >
                        {row[col.key] ? row[col.key] : "0.00"}
                          </p>
                        ): col.key === "requested" && row.hasOwnProperty(col.key) ? (
                          <p>{row[col.key]}</p>
                        ): 
                        
                        (
                          row[col.key] || <p>No Audit</p>
                        )}

                      </td>
                    ))}
                  </tr>
                ))}

              </CommonTable>
            </div>
          </Col>
        </Row>
      </Card>

      {/* <Modal isOpen={modal} toggle={toggleModal} centered> */}
       
          <RouteModal isOpen={modal} 
          toggle={toggleModal}
          size="lg" 
          content={
          <>
          <ModalBody className="text-center" style={{ position: "relative" }}>
          <div
            style={{
              position: "absolute",
              top: -40,
              left: "50%",
              transform: "translateX(-50%)",
              width: 35,
              height: 35,
              backgroundColor: "grey",
              color: "white",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              fontSize: 25,
              fontWeight: "bold",
            }}
            onClick={closeModal}
          >
            ×
          </div>
          <ImageCell ImageString={selectedImage} />
         </ModalBody>
        </>
          }/> 
      

      {/* </Modal> */}
      <Modal isOpen={expense_modal} centered>
        {expense_modal && (
          <RouteModal
            title="Update Expense"
            isOpen={expense_modal}
            toggle={() => setexpense_modal(!expense_modal)}
            size="md"
            content={
              <form onSubmit={handleSubmit}>
                <div className="col-md-12">
                  <div className="col-md-12 mt-2">
                    <CustomInput
                     label="Amount"
                    asterisk={true}
                    style={{
                      borderRadius:'4px'
                    }}
                    type="number"
                      value={ExpesenForm.expAmount}
                      onChange={(e: any) =>
                        handleExpenseInput("expAmount", e.target.value)
                      }
                      onKeyDown={(e) => {
                      if (e.key === "e" || e.key === "E" || e.key === "+" || e.key === "-") {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <CustomInput
                     style={{
                      borderRadius:'4px'
                    }}
                      value={ExpesenForm.Remark}
                      onChange={(e: any) =>
                        handleExpenseInput("Remark", e.target.value)
                      }
                      label="Remark"
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-start mt-3 gap-2 flex-wrap">
                  <Btn
                    style={{ backgroundColor: "#43B9B2", color: "white" }}
                    type="submit"
                  >
                    Update
                  </Btn>
                  <Btn
                    style={{
                      backgroundColor: "#F9FAFC",
                      color: "#000",
                      border: "1px solid #E0E0E0",
                    }}
                    type="button"
                    onClick={() => setexpense_modal(false)}
                  >
                    Cancel
                  </Btn>
                </div>
              </form>
            }
          />
        )}
      </Modal>
    </Col>
  );
};

export default ExpTabsContentTable;
